import clsx from 'clsx'

type SelectablePillProps = {
  label: string
  selected: boolean
  onClick: () => void
  /** Pulsing primary ring drawing attention while the group has no selection yet. */
  pulse?: boolean
  disabled?: boolean
  className?: string
}

export const SelectablePill = ({ label, selected, onClick, pulse, disabled, className }: SelectablePillProps) => (
  <button
    type="button"
    aria-pressed={selected}
    disabled={disabled}
    onClick={onClick}
    className={clsx(
      'tw-rounded-full tw-px-4 tw-py-1.5 tw-text-sm tw-font-medium',
      selected ? 'tw-text-white' : !disabled && 'hover:tw-bg-[var(--page-surface-hover)]',
      disabled && 'tw-cursor-not-allowed tw-opacity-50',
      pulse && 'animate-pill-pulse',
      className,
    )}
    style={
      selected
        ? { background: 'linear-gradient(167deg, var(--primary-gradient-start), var(--primary-gradient-end))' }
        : { border: '1px solid var(--page-border)', color: 'var(--text-secondary)' }
    }
  >
    {label}
  </button>
)
